import { render, staticRenderFns } from "./DomainDialogAccess.vue?vue&type=template&id=9b65a010&scoped=true&"
import script from "./DomainDialogAccess.vue?vue&type=script&lang=ts&"
export * from "./DomainDialogAccess.vue?vue&type=script&lang=ts&"
import style0 from "./DomainDialogAccess.vue?vue&type=style&index=0&id=9b65a010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b65a010",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b65a010')) {
      api.createRecord('9b65a010', component.options)
    } else {
      api.reload('9b65a010', component.options)
    }
    module.hot.accept("./DomainDialogAccess.vue?vue&type=template&id=9b65a010&scoped=true&", function () {
      api.rerender('9b65a010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/domains/DomainDialogAccess.vue"
export default component.exports